import React from 'react';

// Inline SVG icon set matching the reference storefront (stroke icons, 1.5px)
const base = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round', viewBox: '0 0 24 24' };

export const IconMenu = (p) => (
  <svg {...base} {...p}><path d="M3 6h18M3 12h18M3 18h18" /></svg>
);
export const IconClose = (p) => (
  <svg {...base} {...p}><path d="M18 6L6 18M6 6l12 12" /></svg>
);
export const IconSearch = (p) => (
  <svg {...base} {...p}><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>
);
export const IconUser = (p) => (
  <svg {...base} {...p}><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" /></svg>
);
export const IconHeart = (p) => (
  <svg {...base} {...p}><path d="M12 21s-7.5-4.6-9.5-9.3C1.2 8.4 3.3 5 6.7 5c2 0 3.4 1 4.3 2.4C12 6 13.3 5 15.3 5c3.4 0 5.5 3.4 4.2 6.7C17.5 16.4 12 21 12 21z" /></svg>
);
export const IconHeartFilled = (p) => (
  <svg {...base} fill="currentColor" {...p}><path d="M12 21s-7.5-4.6-9.5-9.3C1.2 8.4 3.3 5 6.7 5c2 0 3.4 1 4.3 2.4C12 6 13.3 5 15.3 5c3.4 0 5.5 3.4 4.2 6.7C17.5 16.4 12 21 12 21z" /></svg>
);
export const IconCart = (p) => (
  <svg {...base} {...p}><path d="M6 7h13l-1.3 8H7.5L6 4H3" /><circle cx="8.5" cy="19" r="1.3" /><circle cx="16.5" cy="19" r="1.3" /></svg>
);
export const IconBag = (p) => (
  <svg {...base} {...p}><path d="M5 8h14l-1 13H6L5 8z" /><path d="M9 8V6a3 3 0 016 0v2" /></svg>
);
export const IconHome = (p) => (
  <svg {...base} {...p}><path d="M3 11l9-8 9 8" /><path d="M5 10v10h14V10" /></svg>
);
export const IconGrid = (p) => (
  <svg {...base} {...p}><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></svg>
);
export const IconChevronDown = (p) => (
  <svg {...base} {...p}><path d="M6 9l6 6 6-6" /></svg>
);
export const IconChevronRight = (p) => (
  <svg {...base} {...p}><path d="M9 6l6 6-6 6" /></svg>
);
export const IconChevronLeft = (p) => (
  <svg {...base} {...p}><path d="M15 6l-6 6 6 6" /></svg>
);
export const IconArrowUp = (p) => (
  <svg {...base} {...p}><path d="M12 19V5M5 12l7-7 7 7" /></svg>
);
export const IconArrowRight = (p) => (
  <svg {...base} {...p}><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);
export const IconCompare = (p) => (
  <svg {...base} {...p}><path d="M16 3l4 4-4 4" /><path d="M20 7H8a4 4 0 00-4 4" /><path d="M8 21l-4-4 4-4" /><path d="M4 17h12a4 4 0 004-4" /></svg>
);
export const IconEye = (p) => (
  <svg {...base} {...p}><path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></svg>
);
export const IconMail = (p) => (
  <svg {...base} {...p}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></svg>
);
export const IconPhone = (p) => (
  <svg {...base} {...p}><path d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" /></svg>
);
export const IconStar = ({ filled = true, ...p }) => (
  <svg viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.5" {...p}><path d="M12 2.5l2.9 6.2 6.8.8-5 4.7 1.3 6.8L12 17.7 6 21l1.3-6.8-5-4.7 6.8-.8L12 2.5z" /></svg>
);
export const IconCheck = (p) => (
  <svg {...base} {...p}><path d="M5 12l5 5L20 7" /></svg>
);
export const IconTrash = (p) => (
  <svg {...base} {...p}><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" /></svg>
);
export const IconPlus = (p) => (
  <svg {...base} {...p}><path d="M12 5v14M5 12h14" /></svg>
);
export const IconMinus = (p) => (
  <svg {...base} {...p}><path d="M5 12h14" /></svg>
);
export const IconWhatsapp = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M12 2a10 10 0 00-8.6 15.1L2 22l5.1-1.3A10 10 0 1012 2zm0 18.2a8.2 8.2 0 01-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1112 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.6.8-.8 1-.3.2-.5.1a6.7 6.7 0 01-3.3-2.9c-.3-.4.3-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 00-.7.3 2.9 2.9 0 00-.9 2.2 5 5 0 001 2.6 11.4 11.4 0 004.4 3.9c1.6.7 2.3.8 3.1.6a2.7 2.7 0 001.7-1.2 2.1 2.1 0 00.2-1.2c-.1-.1-.3-.2-.5-.3z" /></svg>
);
export const IconFacebook = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M14 8h3V4h-3a4 4 0 00-4 4v2H7v4h3v8h4v-8h3l1-4h-4V8z" /></svg>
);
export const IconInstagram = (p) => (
  <svg {...base} {...p}><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" /></svg>
);
export const IconTiktok = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M16.5 3c.3 2.3 1.7 3.8 4 4v3.4c-1.5 0-2.9-.5-4-1.3v6.4a5.7 5.7 0 11-5.7-5.7c.3 0 .7 0 1 .1v3.5a2.3 2.3 0 10 1.3 2.1V3h3.4z" /></svg>
);
export const IconYoutube = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M22 8.2a2.8 2.8 0 00-2-2C18.3 6 12 6 12 6s-6.3 0-8 .2a2.8 2.8 0 00-2 2A29 29 0 001.8 12 29 29 0 002 15.8a2.8 2.8 0 002 2c1.7.2 8 .2 8 .2s6.3 0 8-.2a2.8 2.8 0 002-2 29 29 0 00.2-3.8 29 29 0 00-.2-3.8zM10 15V9l5.2 3L10 15z" /></svg>
);
export const IconTwitter = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M18.2 2h3.4l-7.4 8.5L23 22h-6.8l-5.3-7-6.1 7H1.4l7.9-9L1 2h7l4.8 6.4L18.2 2zm-1.2 18h1.9L7.1 3.9H5.1L17 20z" /></svg>
);
export const IconPinterest = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M12 2a10 10 0 00-3.6 19.3c-.1-.8-.2-2 0-2.9l1.2-5s-.3-.6-.3-1.5c0-1.4.8-2.4 1.8-2.4.9 0 1.3.6 1.3 1.4 0 .9-.5 2.1-.8 3.3-.2 1 .5 1.8 1.5 1.8 1.8 0 3.1-1.9 3.1-4.6 0-2.4-1.7-4-4.2-4a4.3 4.3 0 00-4.5 4.3c0 .9.3 1.8.8 2.3.1.1.1.2.1.3l-.3 1.1c0 .2-.1.2-.3.1-1.2-.6-2-2.3-2-3.8 0-3.1 2.2-5.9 6.4-5.9 3.4 0 6 2.4 6 5.6 0 3.4-2.1 6.1-5.1 6.1-1 0-1.9-.5-2.2-1.1l-.6 2.3c-.2.9-.8 2-1.2 2.6A10 10 0 1012 2z" /></svg>
);
export const IconLinkedin = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M6.5 8.5H3V21h3.5V8.5zM4.7 3a2 2 0 100 4 2 2 0 000-4zM21 13.4c0-3.4-1.8-5.2-4.4-5.2-1.9 0-2.8 1-3.3 1.8V8.5H9.9V21h3.4v-6.6c0-1.7.6-2.8 2.1-2.8 1.3 0 2 .9 2 2.8V21H21v-7.6z" /></svg>
);
